import { SignupData } from 'context/types';

export interface RawPayload extends Omit<SignupData, 'country'> {
  country?: string;
}

type ExcludedAttributes =
  | 'password'
  | 'amazonOauthAccessToken'
  | 'mwsAuthToken'
  | 'spapiOauthCode'
  | 'access_token'
  | 'secret';

export type BasePayload = Omit<RawPayload, ExcludedAttributes>;

/**
 * Waiting list types for lead tracking
 */
export enum WaitingList {
  MOBILE = 'mobile',
  ROW = 'ROW',
}

/**
 * Base traits for lead events sent to Pensieve
 */
export interface LeadTraitsBase extends Omit<BasePayload, 'companyName' | 'marketingConsent'> {
  company?: {
    name: string | undefined;
  };
  signup_waiting_list?: WaitingList;
  get_address?: boolean;
  marketingConsent?: boolean;
  marketingConsentDate?: string;
}

export type LeadTraitsWithUTMs = LeadTraitsBase & UTMDataType;
export type LeadTraits = LeadTraitsBase | LeadTraitsWithUTMs;

/**
 * UTM data extracted from campaign cookies
 */
export type UTMDataType = {
  utm_1st_URL?: string;
  utm_1st_campaign?: string;
  utm_1st_content?: string;
  utm_1st_medium?: string;
  utm_1st_referrer?: string;
  utm_1st_source?: string;
  utm_1st_term?: string;
  utm_1st_campaignid?: string;
  utm_1st_click_date?: string;
  utm_1st_gclid?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_referrer?: string;
  utm_source?: string;
  utm_term?: string;
  utm_campaignid?: string;
  utm_click_date?: string;
  utm_gclid?: string;
  lead_type?: string;
  utm_last_page: string;
};
